"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// ConfigurePrompts.tsx
const react_1 = require("react");
const react_native_1 = require("react-native");
const NotesView_1 = __importDefault(require("../../component/NotesView"));
const colors_1 = require("../../common/colors");
const character_1 = require("../../services/character");
const constants_1 = require("../../common/constants");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const AppText_1 = require("../../component/AppText");
const react_redux_1 = require("react-redux");
const user_1 = require("../../store/selectors/user");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const ConfigurePrompts = () => {
    const [allPrompts, setAllPrompts] = (0, react_1.useState)([]);
    const [noteText, setNoteText] = (0, react_1.useState)('');
    const [prompts, setPrompts] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [notesMap, setNotesMap] = (0, react_1.useState)({});
    const [isEditing, setIsEditing] = (0, react_1.useState)(true);
    const { request } = (0, useRequest_1.default)();
    const fbUser = (0, react_redux_1.useSelector)(user_1.selectUser);
    const isAdmin = constants_1.ADMIN_EMAILS.includes(fbUser?.email ?? '');
    (0, react_1.useEffect)(() => {
        const loadPrompts = async () => {
            setLoading(true);
            setError(null);
            const response = await request(character_1.getPrompts);
            if (response) {
                const filteredPrompts = response.data
                    .filter((prompt) => prompt.promptType === 'DOC_SUMMARY_INVISIBLE_AREA_OF_FOCUS_CONTEXT' ||
                    prompt.promptType === 'DOC_SUMMARY_INVISIBLE_USER_CONTEXT' ||
                    prompt.promptType === 'DOC_CHARACTER_INVISIBLE_CONTEXT' ||
                    prompt.promptType === 'DOC_SUMMARY_INVISIBLE_USER_CONTEXT' ||
                    prompt.promptType === 'DEFAULT_INVISIBLE_NOTE_TOC_CONTEXT' ||
                    prompt.promptType === 'DEFAULT_INVISIBLE_NOTE_PROJECT_BRIEF_CONTEXT' ||
                    prompt.promptType === 'DEFAULT_INVISIBLE_NOTE_FAQS_CONTEXT' ||
                    prompt.promptType == 'DEFAULT_INVISIBLE_NOTE_CASE_STUDY_CONTEXT' ||
                    prompt.promptType === 'DEFAULT_OPENAI_AUDIO_GEN_MODEL' ||
                    prompt.promptType === 'DEFAULT_GOOGLE_AUDIO_GEN_MODEL' ||
                    prompt.promptType === 'DEFAULT_TITLE_GEN_CONTEXT' ||
                    prompt.promptType === 'DEFAULT_SUMMARY_OPENAI_MODEL' ||
                    prompt.promptType === 'DEFAULT_IMAGE_DESCRIPTION_GEN_CONTEXT' ||
                    prompt.promptType === 'DOC_SUMMARY_INVISIBLE_CONTEXT' ||
                    prompt.promptType === 'DEFAULT_MODEL')
                    .map((prompt) => ({
                    ...prompt,
                    isVisible: true
                }));
                setAllPrompts(response.data);
                setPrompts(filteredPrompts);
            }
            setLoading(false);
        };
        loadPrompts();
    }, []);
    const handleScrollToTop = () => {
        // Not Needed in this file
    };
    const handleSave = async (promptType, text) => {
        setIsEditing(false);
        try {
            const response = await request(character_1.updatePrompt, promptType, text);
            if (response) {
                setPrompts(prevPrompts => prevPrompts.map(prompt => prompt.promptType === promptType ? { ...prompt, context: noteText } : prompt));
            }
        }
        catch (err) {
            console.error('Error saving prompt:', err);
            setError('Failed to save prompt');
        }
    };
    if (!isAdmin) {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.accessDeniedText, children: "Access Denied: You do not have permission to view this page." }) }));
    }
    if (loading) {
        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { source: require("../../assets/icons/lottie/spinner.json"), autoPlay: true, loop: true, autoSize: true, resizeMode: "cover", style: {
                        height: 56,
                    } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.accessDeniedText, children: "Loading Prompts..." })] }));
    }
    if (error) {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: styles.accessDeniedText, children: ["Error: ", error] }) }));
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { contentContainerStyle: styles.scrollView, children: prompts.map((prompt) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { gap: 8 }, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.promptHeader, children: prompt.description }), (0, jsx_runtime_1.jsx)(NotesView_1.default, { preFilledValue: prompt.context, notesType: 'prompt', isVisible: prompt.isVisible, onScrollToTop: handleScrollToTop, onSave: (text) => handleSave(prompt.promptType, text) }, prompt.promptType)] }))) }) }));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors_1.Colors.DARK_700,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 16,
    },
    promptHeader: {
        color: colors_1.Colors.white,
        justifyContent: 'flex-start',
        fontSize: 20,
    },
    scrollView: {
        flex: 1,
        maxWidth: 768,
        width: '100%',
        gap: 16,
    },
    accessDeniedText: {
        color: colors_1.Colors.white,
        fontSize: 16,
        textAlign: 'center',
    },
});
exports.default = (0, react_1.memo)(ConfigurePrompts);
